export default {
  set(state, payload) {
    state[payload.itemName] = payload.content
  },
  setLoader(state, payload) {
    state[payload.name] = payload.boolean
  },
  async setInArray(state, payload) {
    await state[payload.itemName][payload.arrayName].push(payload.content)
  },
  setCC(state, payload) {
    payload.content.map(async itemCC => {
      await state[payload.itemName][payload.arrayName].push(itemCC)
    })
  },

  async refreshToken(state, payload) {
    return new Promise((resolve, reject) => {
      if (!window.google || !window.google.accounts || !window.google.accounts.id) {
        console.error('Google Identity Services library not loaded.');
        resolve(false);
        return;
      }

      try {
        console.log("Caiu no try")
        window.google.accounts.id.initialize({
          client_id: '895420842124-mfi4vmbnn6fi4r54n3usml7pe9l2qbru.apps.googleusercontent.com',
          callback: (credentialResponse) => {
            console.log('GIS Initialize Callback - credentialResponse:', credentialResponse);
            if (credentialResponse && credentialResponse.credential) {
              const newIdToken = credentialResponse.credential;
              console.log('newIdToken')
              console.log(newIdToken)
              let usuarioLogado = JSON.parse(localStorage.getItem('usuarioLogado'))
              usuarioLogado.token = newIdToken
              localStorage.setItem('usuarioLogado', JSON.stringify(usuarioLogado))
              state.loggedUser.token = newIdToken

              console.log('Token ID atualizado com sucesso via action.');
              resolve(true);
              console.log('GIS Initialize Callback - newIdToken:', newIdToken);
              let usuarioLogadoString = localStorage.getItem('usuarioLogado');
              if (usuarioLogadoString) {
                let usuarioLogado = JSON.parse(usuarioLogadoString);
                usuarioLogado.token = newIdToken;
                localStorage.setItem('usuarioLogado', JSON.stringify(usuarioLogado));
                state.loggedUser.token = newIdToken; // Correctly mutating state
                console.log('Token ID atualizado com sucesso via GIS callback.');
                resolve(true);
              } else {
                console.error('Falha ao atualizar token: usuarioLogado não encontrado no localStorage.');
                resolve(false);
              }
            } else {
              console.error('Falha ao obter novo ID Token durante refresh. CredentialResponse:', credentialResponse);
              console.error('Falha ao obter novo ID Token da GIS. CredentialResponse:', credentialResponse);
              resolve(false);
            }
          },
          error_callback: (error) => {
            console.error('Google Identity Services Initialization Error:', error);
            resolve(false); // Resolve false if initialization itself errors
          }
        });

        window.google.accounts.id.prompt((notification) => {
          console.log('Google One Tap prompt notification:', notification);
          if (notification.isNotDisplayed()) {
            console.warn('Google One Tap prompt was not displayed.', notification.getNotDisplayedReason());
            // O callback de initialize não será chamado se o prompt não for exibido (a menos que auto_select funcione).
            // Você pode querer rejeitar a promise aqui ou lidar com isso de outra forma.
          } else if (notification.isSkippedMoment()) {
            console.info('Google One Tap prompt was skipped by the user.', notification.getSkippedReason());
          }
          // Se o prompt for exibido e o usuário interagir (ou se o auto_select funcionar),
          // o `callback` de `initialize` será chamado.
        });
      } catch (error) {
        console.error('Error during Google Sign-In setup:', error);
        resolve(false); // Or reject(error)
      }
    });
  },
  snackSucesso(state, texto) {
    state.snackbar.ativo = true;
    state.snackbar.tipo = 'success';
    if (texto == undefined) texto = 'Enviado com sucesso!'
    state.snackbar.texto = texto
  },
  snackErro(state, texto) {
    state.snackbar.ativo = true;
    state.snackbar.tipo = 'error';
    if (texto == undefined) texto = 'Houve um erro na aplicação.';
    state.snackbar.texto = texto;
  },
  snackLoading(state, texto) {
    state.snackbar.ativo = true;
    state.snackbar.tipo = 'primary';
    if (texto == undefined) texto = 'Carregando...';
    state.snackbar.texto = texto;
  },
  fecharSnackbar(state) {
    state.snackbar.ativo = false;
  }
}
